/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { createI } from '../../factoriesAny.js';
export var iDependencies = {
  ComplexDependencies: ComplexDependencies,
  createI: createI
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesI.generated.js
// module id = 1425
// module chunks = 0